// extracted by mini-css-extract-plugin
export default {"addSubmission-box":"index_addSubmission-box__8pYPK"};